/**
 * Loads the yasna dictionary at runtime, straight from yasna's deployment.
 *
 * Yasna (github.com/rakesh-m/yasna) is hoja's dictionary. It is under active
 * development, so hoja carries none of its code: yasna serves an ES module
 * (search API + <yasna-entry> / <yasna-dictionary> elements) and hoja imports
 * it from REACT_APP_YASNA_EMBED_URL on first use. Each page load revalidates
 * it, so a yasna deploy reaches hoja users without rebuilding hoja.
 *
 * Contract: yasna docs/hoja-integration.md.
 */

// The yasna embed API major this hoja build understands. Yasna bumps its
// API_VERSION only for breaking changes; refusing to run against an unknown
// one gives a clear message instead of a half-broken annotation panel.
export const SUPPORTED_YASNA_API = 1;

export function yasnaEmbedUrl() {
  return process.env.REACT_APP_YASNA_EMBED_URL || null;
}

let pending = null;

export function loadYasna() {
  if (!pending) {
    const url = yasnaEmbedUrl();
    pending = !url
      ? Promise.reject(new Error('The yasna dictionary is not configured (REACT_APP_YASNA_EMBED_URL).'))
      : import(/* webpackIgnore: true */ url).then((mod) => {
          if (mod.API_VERSION !== SUPPORTED_YASNA_API) {
            throw new Error(
              `The yasna dictionary was updated (API v${mod.API_VERSION}); ` +
              `this version of hoja understands v${SUPPORTED_YASNA_API}.`
            );
          }
          return mod;
        });
    // Let a later call retry (e.g. yasna was briefly unreachable).
    pending.catch(() => { pending = null; });
  }
  return pending;
}

// word_sense_id format: {language}__{word}__{disambiguator}
export function languageOfSense(senseId) {
  return (senseId || '').split('__')[0] || null;
}
